import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { reportWebVitals, sendToAnalytics } from './utils/performance';
import { initOpenPanel } from './utils/openpanel';

// Initialize OpenPanel analytics once, before the first render
initOpenPanel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Monitor Core Web Vitals and send to analytics
reportWebVitals(sendToAnalytics);
